import 'quill/dist/quill.core.css';
import 'quill/dist/quill.snow.css';
import 'quill/dist/quill.bubble.css';
import { quillEditor } from 'vue-quill-editor';
import Quill from 'quill';
import CustomBubbleTooltip from './custom-quill-tooltip';
const ImageBlot = Quill.import('formats/image');
const Parchment = Quill.import('parchment');
const BlockEmbedHtml = Quill.import('blots/block/embed');
import { QuillToolbarButton } from './quill-toolbar-helper';
import CustomColor from '@groovepages/gd-ui-kit/components/ColorPickerMenu';
import Vue from 'vue';
import VueI18n from 'vue-i18n';
import engvars from '@/../../packages-lang/en.json';
import ptvars from '@/../../packages-lang/pt.json';
const Align = Quill.import('attributors/style/align');
const Icons = Quill.import('ui/icons');
Icons.align.left = Icons.align['']; // set icon for 'left' option, otherwise it's replaced with 'undefined' text
Align.whitelist = ['left', 'center', 'right', 'justify'];
Quill.register(Align, true);


Vue.use(VueI18n);

const messages = {
    'en': engvars,
    'pt': ptvars
};

const i18n = new VueI18n({
    locale: 'en',
    messages,
});

export default {
    data() {
        return {
            quillInstance: '',
            changeToolbarQlFormatsEl: null,
        };
    },
    components: {
        quillEditor,
        CustomColor
    },
    props: {
        addElBtnCustomRef: {},
    },
    methods: {
        getQuillEditorOptions(param) {
            let quill = this.quillInstance;
            if (!param) {
                return {
                    modules: {
                        toolbar: false,
                    },
                    theme: 'bubble',
                };
            }

            const toolbar = [
                ['bold', 'italic', 'underline', 'strike']
            ];

            toolbar.push(['link']);
            toolbar.push([{ list: "ordered" }, { list: "bullet" }])

            if (!['page-heading', 'outline-heading'].includes(param)) {
                /**
                 * 'page-description',
                 * 'section-heading',
                 * 'section-description',
                 * 'section-paragraph' 
                 * */

                toolbar.push([{ 'header': [2, 3, false] }], );
            }

            toolbar.push([{ align: ['left', 'center', 'right', 'justify'] }, { color: [] }, { background: [] }]);
            return {
                modules: {
                    toolbar,
                },
                theme: 'bubble',
                scrollingContainer: '#video-library-height',
                bounds: "#editor-bound",
            };
        },
        onEditorReady(quill) {
            this.quillInstance = quill;
        },
        onEditorChange({ quill, html, text }) {
            this.theBlockBlot(quill);
        },
        onEditorFocus(quill) {
            this.theBlockBlot(quill);
            this.vueQuillInit(quill);
        },
        theBlockBlot(quill) {
            setTimeout(() => {
                const Block = Quill.import('blots/block');
                const range = quill.getSelection(true);
                if (range == null) return;
                if (range.length === 0) {
                    const [block, offset] = quill.scroll.descendant(Block, range.index);
                    if (
                        block != null &&
                        block.domNode.firstChild instanceof HTMLBRElement
                    ) {
                        this.showToolbar = true;
                        this.showControls = false;
                        const lineBounds = quill.getBounds(range);
                        this.topPosition = lineBounds.top - 5;
                    } else {
                        this.showToolbar = false;
                    }
                }
            }, 300);
        },
        disableEnter(quill) {
            // quill.keyboard.bindings.handleEnter = {
            //     key: 13,
            //     handler: () => { },
            // };
            // quill.keyboard.bindings['header enter'] = {
            //     key: 13,
            //     handler: () => { },
            // };
            // var keyboard = quill.getModule('keyboard');
            // delete keyboard.bindings['handleEnter'];
            // delete keyboard.bindings['header enter'];

            // keyboard = {
            //     bindings: {
            //         handleEnter: {
            //             key: 13,
            //             handler: () => { },
            //         },
            //         "header enter": {
            //             key: 13,
            //             handler: () => { },
            //         },
            //     }
            // };
            // console.log(keyboard);
        },
        initializeCustomQuillTooltip(quill) {
            
            const customTooltip = new CustomBubbleTooltip(quill);
            const div = document.createElement('div');
            div.classList.add('ql-toolbar');
            div.classList.add('ql-toolbar-embed');

            customTooltip.root.appendChild(div);

            // Edit Button
            const editButton = new QuillToolbarButton({
                icon: `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512"><!--! Font Awesome Pro 6.1.1 by @fontawesome - https://fontawesome.com License - https://fontawesome.com/license (Commercial License) Copyright 2022 Fonticons, Inc.--><path d="M362.7 19.32c25-24.998 65.6-24.998 90.6 0l39.4 39.43c25 24.99 25 65.55 0 90.55l-48.4 48.4-130-129.98 48.4-48.4zm59 200.98L188.5 453.4c-10.4 10.4-23.3 18.1-37.4 22.2L30.77 511c-8.42 2.5-17.53.2-23.74-6.9-6.21-5.3-8.532-14.4-6.054-22.9L36.37 360.9c4.16-14.1 11.79-27 22.2-37.4L291.7 90.34l130 129.96z"/></svg>`
            });

            editButton.onClick = (quill) => {
                let range = quill.getSelection(true);
                let content = quill.getContents(range.index, range.length);
                quill.setSelection(range.index, 0, 'silent');
                if (content.ops[0].insert.image) {
                    quill.container.parentNode.__vue__.$parent.$refs.editImageModal.open();
                }

                if (content.ops[0].insert.addVideo) {
                    quill.container.parentNode.__vue__.$parent.$refs.videoPicker.$refs['video-picker-modal'].open();
                }

                if (content.ops[0].insert.addButton) {
                    quill.container.parentNode.__vue__.$parent.openButtonModal();
                    quill.container.parentNode.__vue__.$parent.buttonValue.text = content.ops[0].insert.addButton.text;
                    quill.container.parentNode.__vue__.$parent.buttonValue.link = content.ops[0].insert.addButton.link;
                    quill.container.parentNode.__vue__.$parent.buttonValue.buttonClassValue = content.ops[0].insert.addButton.class;
                    quill.container.parentNode.__vue__.$parent.buttonValue.backgroundColor = content.ops[0].insert.addButton.backgroundColor;
                    quill.container.parentNode.__vue__.$parent.buttonValue.textColor = content.ops[0].insert.addButton.textColor;
                    quill.container.parentNode.__vue__.$parent.buttonValue.buttonTargetValue = content.ops[0].insert.addButton.target;
                    quill.container.parentNode.__vue__.$parent.buttonTargetValue = content.ops[0].insert.addButton.target == '_self' ? false : true;
                    quill.container.parentNode.__vue__.$parent.ButtonAlign();
                    quill.container.parentNode.__vue__.$parent.buttonValue.class = content.ops[0].insert.addButton.class;
                    quill.container.parentNode.__vue__.$parent.isEditButton = true;
                    quill.container.parentNode.__vue__.$parent.buttonDefaultColour = content.ops[0].insert.addButton.backgroundColor=='rgb(253, 100, 129)'&& content.ops[0].insert.addButton.textColor == 'rgb(255, 255, 255)'?true:false;
                }

            };
            editButton.attach(quill, customTooltip);

            const toolbarButton = new QuillToolbarButton({
                icon: `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 448 512"><path d="M120 256C120 286.9 94.93 312 64 312C33.07 312 8 286.9 8 256C8 225.1 33.07 200 64 200C94.93 200 120 225.1 120 256zM280 256C280 286.9 254.9 312 224 312C193.1 312 168 286.9 168 256C168 225.1 193.1 200 224 200C254.9 200 280 225.1 280 256zM328 256C328 225.1 353.1 200 384 200C414.9 200 440 225.1 440 256C440 286.9 414.9 312 384 312C353.1 312 328 286.9 328 256z"/></svg>`
            });

            this.changeToolbarQlFormatsEl = toolbarButton.qlFormatsEl;

            toolbarButton.onClick = (quill) => {
                const range = quill.getSelection();
                quill.setSelection(range.index, 0, 'user');
                quill.setSelection(range.index, 1, 'user');
            };


            // Trash
            const trashButton = new QuillToolbarButton({
                icon: `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 448 512"><!--! Font Awesome Pro 6.1.1 by @fontawesome - https://fontawesome.com License - https://fontawesome.com/license (Commercial License) Copyright 2022 Fonticons, Inc.--><path d="M135.2 17.69C140.6 6.848 151.7 0 163.8 0h120.4c12.1 0 23.2 6.848 28.6 17.69L320 32h96c17.7 0 32 14.33 32 32s-14.3 32-32 32H32C14.33 96 0 81.67 0 64s14.33-32 32-32h96l7.2-14.31zM31.1 128H416v320c0 35.3-28.7 64-64 64H95.1c-34.45 0-64-28.7-64-64V128zm80 80v224c0 8.8 8.1 16 16 16 9.7 0 16-7.2 16-16V208c0-8.8-6.3-16-16-16-7.9 0-16 7.2-16 16zm96 0v224c0 8.8 8.1 16 16 16 9.7 0 16.9-7.2 16.9-16V208c0-8.8-7.2-16-16.9-16-7.9 0-16 7.2-16 16zm96.9 0v224c0 8.8 7.2 16 16 16s16-7.2 16-16V208c0-8.8-7.2-16-16-16s-16 7.2-16 16z"/></svg>`
            });
            trashButton.onClick = function(quill) {
                const range = quill.getSelection();
                quill.deleteText(range);
            };
            // toolbarButton.attach(quill, customTooltip);
            trashButton.attach(quill, customTooltip);

            return customTooltip;
        },
        trickClickIframe(evt) {
            this.changeToolbarQlFormatsEl.style.display = 'none';
            evt.preventDefault();
            evt.stopPropagation();
            evt.stopImmediatePropagation();
            const closestQuillContainer = document.activeElement.closest('.ql-container');
            if (!closestQuillContainer) {
                return;
            }
            window.focus();
            const quill = closestQuillContainer.__quill;
            if (!quill) {
                return;
            }
            window.setTimeout(() => {
                const range = quill.getSelection();
                let p = Parchment.find(document.activeElement);

                if (!p) {
                    p = Parchment.find(document.activeElement.closest('.video-iframe-wrapper'));
                }
                if (p instanceof BlockEmbedHtml) {
                    const off = p.offset(quill.scroll);
                    if (!range) {
                        setTimeout(() => {
                            quill.focus();
                        });
                    }
                    quill.setSelection(off, 0, 'silent');
                    quill.setSelection(off, 1, 'silent');
                }
            }, 0);
        },
        vueQuillInit(quill) {
            const customTooltip = this.initializeCustomQuillTooltip(quill);

            window.removeEventListener('blur', this.trickClickIframe);
            window.addEventListener('blur', this.trickClickIframe);

            // Click on images
            quill.root.addEventListener('click', (ev) => {
                const range = quill.getSelection();
                if (!range) {
                    const p = Parchment.find(ev.target);
                    if (p instanceof ImageBlot) {
                        const off = p.offset(quill.scroll);
                        quill.setSelection(off, 1, 'silent');
                        return;
                    }
                }
                if (!range) {
                    return;
                }

                if (range.length > 1) {
                    return;
                }

                const image = Parchment.find(ev.target);
                if (image instanceof ImageBlot) {
                    this.changeToolbarQlFormatsEl.style.display = 'block';
                    quill.setSelection(image.offset(quill.scroll), 0, 'user');
                    quill.setSelection(image.offset(quill.scroll), 1, 'silent');
                }
            });

            // Custom tooltip handle
            quill.on('selection-change', (range, oldRange, source) => {
                customTooltip.hide();
                if (!range) return;

                const content = quill.getContents(range.index, range.length);

                if (range.length == 1 && content.ops[0].insert.addButton) {
                    const defaultTooltip = quill.theme.tooltip;
                    customTooltip.show();
                    defaultTooltip.hide();
                } else {
                    customTooltip.hide();
                }

                // Custom color picker
                if (quill.getContents(range.index, range.length).ops[0] && quill.getContents(range.index, range.length).ops[0].attributes && quill.getContents(range.index, range.length).ops[0].attributes.color)
                    vm.color = quill.getContents(range.index, range.length).ops[0].attributes.color;
                else
                    vm.color = '';

                if (quill.getContents(range.index, range.length).ops[0] && quill.getContents(range.index, range.length).ops[0].attributes && quill.getContents(range.index, range.length).ops[0].attributes.background)
                    vm2.color = quill.getContents(range.index, range.length).ops[0].attributes.background;
                else
                    vm2.color = '';
            });

            const { tooltip } = quill.theme;

            tooltip.root.querySelector('.ql-color .ql-picker-options').innerHTML = '<div class="one"></div>';
            tooltip.root.querySelector('.ql-background .ql-picker-options').innerHTML = '<div class="two"></div>';
            // create component constructor
            const cookiesOrigin = null; // PLEASE DEFINE IT TO MAKE THE COOKIES FEATURE WORKS

            const vueColorPicker = Vue.extend(CustomColor);
            let color = quill.getFormat().color || '';
            const vm = new vueColorPicker({
                    i18n,
                    propsData: {
                        value: color,
                        immediateChange: true,
                        cookiesOrigin: cookiesOrigin
                    }
                })
                .$mount('.ql-color .ql-picker-options > div.one')
                .$on('change', (value) => {
                    vm.value = value;
                })
                .$on('close-direct', function() {
                    tooltip.root.querySelector('span.ql-color.ql-picker.ql-color-picker').classList.remove("ql-expanded");
                    tooltip.root.querySelector('span.ql-color.ql-picker.ql-color-picker .ql-picker-label').setAttribute("aria-expanded", false);
                    tooltip.root.querySelector('span.ql-color.ql-picker.ql-color-picker .ql-picker-options').setAttribute("aria-expanded", false);
                })
                .$on('push-color', function(color) {
                    quill.format('color', color);
                });


            const vueColorPickerBG = Vue.extend(CustomColor);
            let bgColor = quill.getFormat().background || '';
            const vm2 = new vueColorPickerBG({
                    i18n,
                    propsData: {
                        value: bgColor,
                        immediateChange: true,
                        cookiesOrigin: cookiesOrigin
                    }
                })
                .$mount('.ql-background .ql-picker-options > div.two')
                .$on('change', (value) => {
                    vm2.value = value;
                })
                .$on('close-direct', function() {
                    tooltip.root.querySelector('span.ql-background.ql-picker.ql-color-picker').classList.remove("ql-expanded");
                    tooltip.root.querySelector('span.ql-background.ql-picker.ql-color-picker .ql-picker-label').setAttribute("aria-expanded", false);
                    tooltip.root.querySelector('span.ql-background.ql-picker.ql-color-picker .ql-picker-options').setAttribute("aria-expanded", false);
                })
                .$on('push-color', function(color) {
                    quill.format('background', color);
                });
        }
    }
};